<template>
  <div class="make-job-post">
    <div class="control-width mx-auto">
      <div class="p-4 p-md-5 border shadow-sm add-rounded">
        <h4 class="mb-3 font-weight-bold kova-text">Select skill(s) you require from your developer</h4>

        <a-select
          mode="multiple"
          class="w-100 mt-4 mb-5"
          size="large"
          v-model="skills"
          placeholder="What skills are required"
        >
          <a-select-option v-for="devskill in devskills" :key="devskill">{{devskill}}</a-select-option>
        </a-select>

        <h6
          class="mt-3 font-weight-bold mb-4 text-left"
        >Write a detailed task description of what developer(s) will build</h6>
        <a-textarea
          placeholder="Job description here"
          class="m-auto w-100"
          v-model="taskDescription"
          :rows="4"
        />

        <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
          <div class="row">
            <div class="col text-left">
              <button
                class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded"
                v-on:click="goBack"
              >Back</button>
            </div>
            <div class="col text-right">
              <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="next">Next</button>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right kova-text pt-3 mr-4 mb-5"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "make-job-post",
  data() {
    return {
      devskills: [
        "Android",
        "IOS",
        "CyberSecurity",
        "Data Engineering",
        "eCommerce",
        "Web Application",
        "Front-end",
        "Back-end",
        "UI/UX",
        "Artificial Intelligence",
        "Blockchain",
        "Integration",
        "Project management",
        "DApps",
        "DevOps"
      ],
      skills: this.$store.state.client.clientData.skills,
      taskDescription: this.$store.state.client.clientData.taskDescription
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    next() {
      const { skills, taskDescription } = this;
      this.$store.commit("client/updateClient", {
        skills,
        taskDescription
      });
      this.$router.push("bio");
    },
    skip() {
      this.$router.push("bio");
    }
  }
};
</script>
<style scoped>
.control-width {
  width: 600px;
}
.input-title {
  font-size: 15px;
}
@media (min-width: 768px) and (max-width: 991px) {
}
@media (max-width: 767px) {
  .control-width {
    width: 500px;
  }
}
@media (max-width: 550px) {
  .control-width {
    width: 98%;
  }
}
</style>
